import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-slate-800 bg-slate-900/50 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxn7p7puuay">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop4rw4hari8">I {totalBonuses} <span className="text-amber-400" data-id="element-21" data-mp="15pw26yqqckwu">Bonus Esclusivi</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-slate-800 bg-slate-950 shadow-lg shadow-black/30" data-id="element-22" data-mp="1jgr4ttamy5rz">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-slate-800 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="r083m59xo0ct" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-slate-700 bg-slate-900 text-orange-400" data-id="element-24" data-mp="2jixqooh9uyz9">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2oitwmt9j50hg" />
                </span>
                <div data-id="element-26" data-mp="1qvbonknp02ei">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-27" data-mp="1vs217y0agfv6">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-white" data-id="element-28" data-mp="20qvd5lzxfyt8">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-300" data-id="element-29" data-mp="25rj3s6k8udmx">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-amber-400 bg-slate-950 px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-30" data-mp="3h5em1o6g32id">
          <div data-id="element-31" data-mp="1c4tzvj5qsde1">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-32" data-mp="1c53trhtwr4p0">Valore di tutti i {totalBonuses} bonus</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-slate-300 line-through decoration-amber-400 decoration-2" data-id="element-33" data-mp="1q3jzb5g1ap5k">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="ydffb7w6s44v">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-35" data-mp="tdt577bnn40a">Il tuo prezzo oggi</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-amber-400" data-id="element-36" data-mp="174zaxl5j1xvm">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="12e93m2djjkya" /> GRATIS
            </p>
          </div>
        </div>
      </div>
    </section>;
}